import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const ApprehensionTypes = ({data}) => {
  const reportId = "apprehension-types";
  const reportName = `Apreensões por tipo`

  useEffect(() => {
    const values = data.slice(0,5).map(i => i.qty);
    const labels = data.slice(0,5).map(i => i.type);

    GraphicUtils.barChart(reportId, values, labels, false);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, reportName);

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{`${reportName} ${data?.length >= 5 ? ' (TOP 5)' : ''}`}</span>
        <div className="mt-3" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default ApprehensionTypes;